module.exports = __webpack_public_path__ + "88c9a52ad6ac08e573fd96481dca3149.pdf";